import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Tabs } from '@statsbomb/kitbag-components';
import { useEffect, useState } from 'react';
import { isSettingsPanelOpenAtom } from '@/atoms/sidebar';
import { useSetAtom } from 'jotai';
import { Tab } from '@/types/tabs';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';
import { PLAYER_ID, RADAR_TEMPLATE } from '@/consts/searchKeys';

export const PageSubNav = ({ items }: { items: { label: string; route: string }[] }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);
  const { pathname } = useLocation();
  const setIsSettingsPanelOpen = useSetAtom(isSettingsPanelOpenAtom);

  const hasSearchParams = searchParams.size > 0;
  // persist query params between tabs except for the ones we explicitly exclude
  const newQueryString = updateQueryString([], [PLAYER_ID, RADAR_TEMPLATE]);
  const [activeTab, setActiveTab] = useState<string>();

  useEffect(() => {
    const defaultTab = items.find(item => pathname.includes(item.route))?.route || items[0].route;
    setActiveTab(defaultTab);
  }, [pathname]);

  const tabs = items.map(item => ({
    label: item.label,
    value: item.route,
  }));

  return (
    <Tabs
      tabs={tabs}
      onTabChange={(_: React.MouseEvent<HTMLButtonElement, MouseEvent>, { value }: Tab<string>) => {
        const navigatePath = hasSearchParams ? `${value}?${newQueryString}` : value;
        setIsSettingsPanelOpen(false);
        setActiveTab(value);
        navigate(navigatePath);
      }}
      activeTab={activeTab}
    />
  );
};
